import { mapGetters, mapActions, mapState } from 'vuex'
import formButton from '@/components/common/form-button/form-button.vue'
import chart from '@/components/common/chart/chart'
import moment from 'moment'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
// import faArchive from '@fortawesome/fontawesome-free-solid/faArchive'
import { faArchive, faReply } from '@fortawesome/fontawesome-free-solid'
import softApproval from '@/components/common/soft-approval/soft-approval.vue'
import { debounce } from 'lodash'

const POINTS = {
  NOT_RENDERED: 0,
  RENDER: 3
}

export default {
  components: {
    formButton,
    chart,
    FontAwesomeIcon,
    softApproval
  },
  data() {
    return {
      chartOptions: {
        layout: 0,
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                display: false,
                callback: () => {}
              },
              gridLines: {
                drawBorder: false
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                display: false,
                callback: () => {}
              },
              gridLines: {
                drawBorder: false
              }
            }
          ]
        }
      }
    }
  },
  props: {
    competition: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapActions('app', ['redirectToPolling']),
    ...mapActions('competition', ['cloneConfiguration', 'updateCompetitionStatus']),
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapGetters('competition', ['statuses']),
    cloneAction: debounce(function () {
      if (this.competition.template.soft_approval) {
        this.setCurrentPopup(this.softApprovalPopup)
      } else {
        this.cloneCompetition()
      }
    }, 300),
    cloneCompetition: async function (user) {
      try {
        const data = {
          id: this.competition._id
        }
        if (user) {
          data.email = user.email
        }
        const res = await this.cloneConfiguration(data)
        this.$notify({
          text: 'Competition successfully cloned',
          type: 'success'
        })
        await this.redirectToPolling(res.data._id)
      } catch (e) {
        this.$notify({
          text: 'Error while cloning competition',
          type: 'error'
        })
      }
    },
    goToCompetition: function (e) {
      if (e.target.nodeName !== 'BUTTON' && !this.currentPopup) {
        this.redirectToPolling(this.competition._id)
      }
    },
    setToClosed: async function (id) {
      try {
        await this.$dialog.confirm('Are you sure want to move this competition to the vault?')
        await this.updateCompetitionStatus({ id, status: 'closed' })
      } catch (err) {
        if (err !== false) {
          this.$notify({
            text: 'Could not move this competition to the vault, try again later',
            type: 'error'
          })
        }
      }
    },
    setCompleted: async function (id) {
      try {
        await this.$dialog.confirm('Are you sure want to take this competition out of the vault?')
        await this.updateCompetitionStatus({ id, status: 'completed' })
      } catch (err) {
        if (err !== false) {
          this.$notify({
            text: 'Could not take this competition out of the vault, try again later',
            type: 'error'
          })
        }
      }
    }
  },
  computed: {
    ...mapState('popup', ['currentPopup']),
    showCloneButton: function () {
      return !['archived', 'closed'].includes(this.competition.status)
    },
    icon: function () {
      return faArchive
    },
    faReplyIcon: function () {
      return faReply
    },
    softApprovalPopup: function () {
      return `softApprovalPopup-${this.competition._id}`
    },
    competitionStatus: function () {
      let status
      switch (this.competition.status) {
        case 'active':
          status = 'live'
          break
        default:
          status = this.competition.status
      }
      return status
    },
    mainStats: function () {
      return this.competition.stats.main
    },
    overTimeStats: function () {
      return this.competition.stats.overTime.stats
    },
    validEntries: function () {
      return this.mainStats.accepted
    },
    uniqueEntries: function () {
      return this.mainStats.uniqueUsers
    },
    timeToClose: function () {
      return moment(this.competition.core.end_date).fromNow()
    },
    chartData: function () {
      const data = this.overTimeStats.map((stat) => stat.count)
      return {
        labels: this.overTimeStats.map((stat) => stat.time),
        datasets: [
          {
            label: 'entries',
            borderColor: '#FF0000',
            fill: false,
            pointRadius: data.length === 1 ? POINTS.RENDER : POINTS.NOT_RENDERED,
            steppedLine: false,
            data
          }
        ]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/cards/card-competition/card-competition.js